import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormControl as FormControlWancom } from '../form-control.model';
import { UntypedFormControl } from '@angular/forms';
import { MatSliderChange } from '@angular/material/slider';

@Component({
	selector: 'wncm-form-control-not-sign-since',
	templateUrl: './form-control-not-sign-since.component.html',
	styleUrls: ['./form-control-not-sign-since.component.scss']
})
export class FormControlNotSignSinceComponent implements OnInit {
	@Input() control: UntypedFormControl | UntypedFormControl;

	@Input() placeholder: string;

	@Output() sendValue: EventEmitter<number> = new EventEmitter<number>();

	@ViewChild('checkbox', { static: true }) checkbox: ElementRef;

	constructor() {}

	ngOnInit() {
		this.control.valueChanges.subscribe((value) => {
			this.sendValue.emit(value);
		});
	}

	public checkSet(value: boolean): void {
		this.sendValue.emit(value ? (this.control.value != null ? this.control.value : value) : null);
	}

	public valueChanges(event: any): void {
		this.control.setValue(event.value[event.value.length - 1]);
		const toggle = event.source;
		if (toggle) {
			const group = toggle.buttonToggleGroup;
			if (event.value.some((item) => item == toggle.value)) {
				group.value = [toggle.value];
			}
		}
	}
}
